var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkSlovakia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_23128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V30H60V0Z",
    fill: "#0B4EA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V15H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1566 34.7623C42.1879 32.8217 47.9629 28.9592 47.9629 21.3373C47.9629 13.7061 47.5879 10.2373 47.5879 10.2373H28.716C28.716 10.2373 28.3504 13.7061 28.3504 21.3373C28.3504 28.9686 34.1254 32.8123 38.1566 34.7623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1562 33.75C41.8594 31.9688 47.1562 28.425 47.1562 21.4313C47.1562 14.4375 46.8187 11.25 46.8187 11.25H29.4938C29.4938 11.25 29.1656 14.4375 29.1656 21.4313C29.1562 28.4344 34.4531 31.9688 38.1562 33.75Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3688 19.5936C36.3656 19.6123 34.4062 19.6498 32.6719 19.0686C32.6719 19.0686 32.7094 19.6967 32.7094 20.4186C32.7094 21.1404 32.6625 21.7686 32.6625 21.7686C34.2562 21.2342 36.2344 21.2248 37.3688 21.2342V25.0967H38.9437V21.2342C40.0687 21.2248 42.0469 21.2342 43.6406 21.7686C43.6406 21.7686 43.5938 21.1404 43.5938 20.4186C43.5938 19.6873 43.6406 19.0686 43.6406 19.0686C41.9062 19.6498 39.9469 19.6123 38.9531 19.5936V17.1654C39.8625 17.1654 41.175 17.2029 42.6656 17.6998C42.6656 17.6998 42.6188 17.0811 42.6188 16.3498C42.6188 15.6279 42.6656 14.9998 42.6656 14.9998C41.175 15.4967 39.8625 15.5436 38.9531 15.5342C39 13.9967 39.45 12.0654 39.45 12.0654C39.45 12.0654 38.5219 12.1311 38.1562 12.1311C37.7812 12.1311 36.8625 12.0654 36.8625 12.0654C36.8625 12.0654 37.3125 13.9967 37.3594 15.5342C36.45 15.5436 35.1375 15.4967 33.6469 14.9998C33.6469 14.9998 33.6937 15.6279 33.6937 16.3498C33.6937 17.0811 33.6469 17.6998 33.6469 17.6998C34.8483 17.3124 36.1068 17.1317 37.3688 17.1654V19.6029V19.5936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1559 24.6846C40.0215 24.6846 41.0152 27.2627 41.0152 27.2627C41.0152 27.2627 41.5777 26.0439 43.0965 26.0439C44.1277 26.0439 44.8777 26.9533 45.3652 27.8064C43.4902 30.7783 40.4996 32.6158 38.1559 33.7502C35.8121 32.6252 32.8121 30.7783 30.9465 27.8064C31.434 26.9627 32.184 26.0439 33.2152 26.0439C34.734 26.0439 35.2965 27.2627 35.2965 27.2627C35.2965 27.2627 36.2809 24.6846 38.1559 24.6846Z",
    fill: "#0B4EA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_23128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkSlovakia);
export default __webpack_public_path__ + "static/media/sk Slovakia.514882f79653905712fbb5eb96c07eba.svg";
export { ForwardRef as ReactComponent };